// extracted by mini-css-extract-plugin
export default {"pill":"CoinPill_pill__Uj1Zn","icon":"CoinPill_icon__DuEYA","value":"CoinPill_value__6jlF0"};